import React from 'react';
import { MdCheckCircle } from 'react-icons/md';
import {
    ADMIN,
    ASSISTANT_MANAGER,
    MANAGER
} from 'components/RoleGate/constants';
import RoleButton from 'components/RoleButton';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import { COMPLETE_SPRAY_EVENT_MODAL } from '../CompleteSprayEventModal/constants';

export default function CompleteSprayEventButton(): React.ReactElement {
    return (
        <RoleButton
            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
            params={{
                [COMPLETE_SPRAY_EVENT_MODAL]: true
            }}
            buttonProps={{
                icon: true,
                color: 'black',
                basic: true,
                style: {
                    marginRight: 0,
                    marginLeft: 8
                }
            }}
            ignoreSeason
        >
            <ButtonIconWrapper>
                <MdCheckCircle
                    style={{
                        fontSize: 20
                    }}
                />
            </ButtonIconWrapper>
            Complete
        </RoleButton>
    );
}
